// extracted by mini-css-extract-plugin
export var localeSelector = "_41-0";